import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Phone14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_169)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.14122 1.12155L5.14216 1.12389L6.3788 4.23494C6.53814 4.63576 6.44371 5.11752 6.14477 5.42848L6.13915 5.43433L5.10088 6.49119C5.24348 7.19339 5.62192 7.6928 6.08588 8.21265C6.48676 8.66184 7.04244 8.96475 7.63445 9.05949C7.98576 8.70988 8.33815 8.36133 8.68544 8.00771L8.69321 8.00025C9.00417 7.70131 9.48587 7.60686 9.88669 7.7662L13.0001 9.0038C13.5869 9.23935 13.8774 9.95422 13.5965 10.5276C12.9647 11.8172 11.7543 13.0456 10.3603 13.4938C7.75138 14.3327 4.89475 12.9058 3.08479 11.0567C1.28305 9.21598 -0.173751 6.41039 0.649876 3.79663L0.657127 3.77362L0.665842 3.75113C1.20998 2.34644 2.27973 1.18585 3.62925 0.519369L3.64344 0.513074C4.21676 0.25889 4.9076 0.539545 5.14122 1.12155ZM3.90705 2.07747C3.07797 2.58905 2.43284 3.35707 2.07344 4.27023C1.4396 6.33159 2.759 8.57946 4.15673 10.0074C5.55505 11.436 7.82945 12.7158 9.87771 12.0733C10.7818 11.709 11.5406 11.064 12.0457 10.2386L9.56464 9.25234C9.19215 9.62816 8.81257 10.002 8.44442 10.3702C7.22073 10.8483 5.84493 10.1791 4.99003 9.2373C4.05499 8.35329 3.64362 7.20531 3.52582 5.95408L4.89427 4.56105L3.90705 2.07747Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_169'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Phone14.displayName = 'Phone14';
export default Phone14;
